// Boatswain zone — profiles, invites
import type { ContributorProfile, Invite } from './types'
import type { RequestHelper } from './client'

export function boatswainMethods(r: RequestHelper) {
  return {
    // Profiles
    profiles: {
      me: () => r.get<{ profile: ContributorProfile }>('/hub/profiles/me'),
      update: (data: Partial<ContributorProfile>) => r.put<{ profile: ContributorProfile }>('/hub/profiles/me', data),
      get: (userId: string) => r.get<{ profile: ContributorProfile }>(`/hub/profiles/${userId}`),
      directory: (params?: Record<string, string>) => {
        const query = params ? `?${new URLSearchParams(params).toString()}` : ''
        return r.get<{ profiles: ContributorProfile[] }>(`/hub/profiles/directory${query}`)
      },
      endorse: (userId: string, data: { skill: string }) => r.post<void>(`/hub/profiles/${userId}/endorse`, data),
    },

    // Invites
    invites: {
      list: (params?: Record<string, string>) => {
        const query = params ? `?${new URLSearchParams(params).toString()}` : ''
        return r.get<{ invites: Invite[] }>(`/hub/invites${query}`)
      },
      create: (data: { email: string; project_id?: string; role?: string }) => r.post<{ invite: Invite }>('/hub/invites', data),
      delete: (id: string) => r.del<void>(`/hub/invites/${id}`),
      createReferral: (projectId: string) => r.post<{ link: string }>('/hub/invites/referral', { project_id: projectId }),
    },
  }
}
